import useAccess from "../../../../authorization/hooks/useAccess.js";
import {serverHost} from "../../../../http_common.js";
import axios from "axios";
import {io} from 'socket.io-client';
import useUniverseScanner from './useUniverseScanner';
import { useEffect, useState, useRef, useCallback } from "react";
import socket from "../../../../socket-io.js";
import { persistor } from "../../../../store/front_end_data_base/store.js";
import { useReactToPrint } from "react-to-print";

import SuccessSound from "./sounds/sold.wav";
import ErrorSound from "./sounds/error.wav";
import "./inventoryTerminal.css";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ScanSuccessBip from "./sounds/scannerBips.mp3";
import { useNavigate } from "react-router-dom";
import * as Action from "../../../../store/redux/terminal_reducer.js";
import * as Mongodb from "../../../../store/redux/mongodb.js";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Calculator from "./modalBoxComps/Calculator.jsx";
import CameraIcon from "@mui/icons-material/Camera";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Items from "./ware_house_comps/Items.jsx";
import BannerImg from "./images/banner.png";
// ------------------NEW IMPORTS---------------------
import LayersClearIcon from "@mui/icons-material/LayersClear";
import SettingsRemoteTwoToneIcon from "@mui/icons-material/SettingsRemoteTwoTone";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SettingsPhoneIcon from "@mui/icons-material/SettingsPhone";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import AddIcCallOutlinedIcon from "@mui/icons-material/AddIcCallOutlined";
import DiscountOutlinedIcon from "@mui/icons-material/DiscountOutlined";
import VpnLockOutlinedIcon from "@mui/icons-material/VpnLockOutlined";
import ContactPhoneOutlinedIcon from "@mui/icons-material/ContactPhoneOutlined";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import DoNotDisturbAltRoundedIcon from "@mui/icons-material/DoNotDisturbAltRounded";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
// import SearchIcon from "@mui/icons-material/Search";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CasesIcon from "@mui/icons-material/Cases";

import DiscountIcon from "@mui/icons-material/Discount";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import VideoLibraryRoundedIcon from "@mui/icons-material/VideoLibraryRounded";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import CloseIcon from "@mui/icons-material/Close";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import CalculateIcon from "@mui/icons-material/Calculate";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BedtimeOffIcon from "@mui/icons-material/BedtimeOff";
import GrainIcon from "@mui/icons-material/Grain";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import BalanceIcon from "@mui/icons-material/Balance";
import BackHandIcon from "@mui/icons-material/BackHand";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import SchoolIcon from "@mui/icons-material/School";

import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import SellIcon from "@mui/icons-material/Sell";
import PanToolIcon from "@mui/icons-material/PanTool";

import HeadsetOffIcon from "@mui/icons-material/HeadsetOff";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";


import Counter, { CounterMini } from "./modalBoxComps/Counter.jsx";
import {
  AddNewProduct,
  ClearCart,
  OnHold,
  Quotation,
  SaveDraft,
  Discount,
  HoldedSales,
  Contacts,
} from "./ware_house_comps/functional_comps/InventoryWorkFlows.jsx";

import {
  CashPayment,
  CreditSale,
  MultiPay,
  Debit,
  Gifting,
  PaymentLogs,
  Cheque,
  Account,
} from "./ware_house_comps/payment_buttons/POSExecutions.jsx";
import IsLoading from "../../../../IsLoading.jsx";
import TerminalConsole from "./TerminalConsole.jsx";
import PrintSalesReciept from "./printings_warehouse/PrintSalesReciept.jsx";
import RecentTransaction from "./ware_house_comps/RecentTransaction.jsx";
import AddNewContact from "./ware_house_comps/functional_comps/AddNewContact.jsx";
import RegisterDetailsComp from "./RegisterDetailsComp.jsx";
import AcceptReturn from "./ware_house_comps/AcceptReturn.jsx";
import AlertBar from "../../../../AlertBar.jsx";
import BAR_QR_CODE_SCANNER from "./ware_house_comps/BAR_QR_CODE_SCANNER.jsx";
import PlansBilled from "../../../universe-company-directrory/PlansBilled.jsx";
import { AddShipping } from "./ware_house_comps/AddShipping.jsx";
import CloudScanner from "./CloudScanner.jsx";
import UniCloudChat from "./ware_house_comps/UniCloudChat.jsx";
import TerminalActivityLog from "./ware_house_comps/TerminalActivityLog.jsx";

let queue;

function InventoryTerminal() {
  const access = useAccess();
  const [searchParams, setSearchParams] = useSearchParams();
  const [scannedEvent, setScannedEvent] = useState("");
  const [scannedEventData, setScannedEventData] = useState({});

  const barcodeInputRef = useRef(null);
  // REACT TO PRINT SPECIAL PRINTING FUNTIONS
  const contentRef = useRef(null);
  const salePendingRef = useRef(null);
  const registerCloseRef = useRef(false);
  const registerStateRef = useRef({});
  const [registerClosing, setRegisterClosing] = useState(false);
  const completedSaleRef = useRef(null);
  const saleTimeoutRef = useRef(null);
  const salePrintTimeoutRef = useRef(null);
  const [completedReceipt, setCompletedReceipt] = useState(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  // --------------------------------------------
  const [alert, setAlert] = useState(null);
  const wrapperRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [summationOpen, setSummationOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [display, setDisplay] = useState("");
  const [reveal, setReveal] = useState("");
  const [savedContacts, setSavedContacts] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [contactsError, setContactsError] = useState("");
  // HOOKS-----------------------------
  const [openBrands, setOpenBrands] = useState(false);
  const [openCustomers, setOpenCustomers] = useState(false);

  const [brands, setBrands] = useState("All brands");
  const [isIconButtons, setIsIconButtons] = useState(false);
  const redirect = useNavigate();
  const dispatch = useDispatch();
  const [isFullscreen, setIsFullscreen] = useState(false);
  // ------------------- ITEMS OPEINGING S
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTermContacts, setSearchTermContacts] = useState("");
  const [searchTermBrands, setSearchTermBrands] = useState("");
  const [filteredBrands, setFilteredBrands] = useState([]);
  //   MODAL FUNCTIONS------------------
  const [toggleAside, setToggleAside] = useState("productsf");
  const [showModal, setShowModal] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [showModalBill, setShowModalBill] = useState("");
  const [openModalBill, setOpenModalBill] = useState(false);
  const [customer, setCustomer] = useState("Walk-in Customer");
  const [customerId, setCustomerId] = useState("EDK323K3J2");
  const [paymentMethod, setPaymentMethod] = useState(0);
  const [tax, setTax] = useState(0);
  const [displayReciept, setdisplayReciept] = useState(false);
  const [temporaryAuth, setTemporaryAuth] = useState(false);

  //*&*&**&*&**&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&
  // --------------BARCODE SCANNED FUNCTIONS ----------------------
  const handleBarcodeScan = () => {
    const product = products.find(
      (item) => item.barcode === scannedEvent.trim(),
    );

    if (product) {
      // Play audio notification safely
      // new Audio(ScanSuccessBip).play().catch(() => {});
      addToCart(product);
    } else {
      setAlert({
        message:
          "Product not found, please make sure you have this item barcode registered in the item.",
        type: "warning",
      });
    }

    setScannedEvent("");
    setScannedEventData({});
  };

  // Inside your React component:
  const bipAudioRef = useRef(null);

  useEffect(() => {
    // Preload audio on initial mount
    bipAudioRef.current = new Audio(ScanSuccessBip);
    bipAudioRef.current.preload = "auto";
    bipAudioRef.current.load(); // Explicitly start downloading
  }, []);

  const handleBarcodeScanWITHCamera = (barcode) => {
    const product = products.find((item) => item.barcode === barcode.trim());

    if (bipAudioRef.current) {
      bipAudioRef.current.currentTime = 0;
      bipAudioRef.current.play().catch(() => {});
    }

    if (product) {
      addToCart(product);
    } else {
      setAlert({
        message:
          "Product not found, please make sure you have this item barcode registered in the item.",
        type: "warning",
      });
    }

    setScannedEvent("");
    setScannedEventData({});
  };
  //*&*&**&*&**&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&*&

  // Sync to the browser's actual fullscreen state (including Escape and browser UI).
  useEffect(() => {
    const syncFullscreen = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", syncFullscreen);
    syncFullscreen();
    // Best effort when the user navigated straight to the terminal.
    // Browsers can require a user gesture; the console button remains available.
    if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
      try {
        Promise.resolve(document.documentElement.requestFullscreen()).catch(() => {});
      } catch (_) { /* Fullscreen is optional. */ }
    }
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreen);
      // Restore the browser when leaving the terminal.
      if (document.fullscreenElement === document.documentElement && document.exitFullscreen) {
        try { Promise.resolve(document.exitFullscreen()).catch(() => {}); }
        catch (_) { /* Browser owns fullscreen state. */ }
      }
    };
  }, []);

  const toggleFullscreen = useCallback(async () => {
    try {
      if (document.fullscreenElement) {
        if (document.exitFullscreen) await document.exitFullscreen();
      } else if (document.documentElement.requestFullscreen) {
        await document.documentElement.requestFullscreen();
      } else {
        setAlert({ type: "warning", message: "Fullscreen is not supported by this browser." });
      }
    } catch (_) {
      setAlert({ type: "warning", message: "Your browser blocked fullscreen. Try the fullscreen button again." });
    }
  }, []);

  // USE SELECTORS DATA TYPE SELECTOR----------------------
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );

  const {
    inventory,
    registerId,
    representiveId,
    representiveMail,
    representiveName,
    representiveNumber,
    timeInn,
  } = useSelector((state) => state.terminalActions?.registerData);

  const { switchTerminalView, registerData, itemsSoldCount, registerClosure } = useSelector(
    (state) => state.terminalActions,
  );

  const { cart, sales_reciept, products, discount, contentType, shipping } =
    useSelector((state) => state.terminalActions.inventoryPOS);
  
  useEffect(()=>{if(!companyData?.clientId||!inventory?.inventoryId||!registerData?.registerId||!products?.length||cart?.length)return;let pending;try{pending=JSON.parse(sessionStorage.getItem('universe-pending-draft')||'null');}catch(error){return;}if(!pending||pending.clientId!==companyData.clientId||pending.inventoryId!==inventory.inventoryId)return;const controller=new AbortController();axios.get(`${serverHost}/inventory/client/${encodeURIComponent(companyData.clientId)}/drafts`,{signal:controller.signal}).then(response=>{if(![200,201].includes(response.data.status))throw new Error(response.data.message);const record=(response.data.drafteds||[]).find(record=>record.draftId===pending.draftId&&record.status==='draft');if(!record)throw new Error('Saved draft is no longer available.');const buyings=(record.items||[]).map(line=>{const product=products.find(item=>item.sku===line.sku);if(!product)throw new Error(`Draft item ${line.sku} is unavailable in this inventory.`);return {...product,...line};});if(!controller.signal.aborted){dispatch(Action.attendOnhold({buyings,saleId:`SALE-${window.crypto.randomUUID()}`}));dispatch(Action.dispatchDiscount(record.totals?.discount||{amount:0,type:'FIXED'}));setCustomer(record.customer_name||'Walk-in Customer');setCustomerId(record.customerId||'EDK323K3J2');sessionStorage.removeItem('universe-pending-draft');}}).catch(error=>{if(!controller.signal.aborted)setAlert({type:'error',message:error.response?.data?.message||error.message});});return()=>controller.abort();},[companyData?.clientId,inventory?.inventoryId,registerData?.registerId,products,cart?.length,dispatch]);
  const cartSummations = cart?.reduce(
    (acc, item) => {
      const quantity = Number(item?.soldQuantity || 0);
      const sellingPrice = Number(item?.pricing?.sellingPrice || 0);
      const itemSubtotal = Math.round((sellingPrice * quantity + Number.EPSILON) * 100) / 100;

      acc.totalQty += quantity;
      acc.subtotal += itemSubtotal;

      return acc;
    },
    {
      totalQty: 0,
      subtotal: 0,
      discount: 0,
      tax: 0,
      amountDue: 0,
    },
  ) || { totalQty: 0, subtotal: 0, discount: 0, tax: 0, amountDue: 0 };

  // --- Global Calculations Outside the Loop ---

  // 1. Determine Discount (Handles either flat amount OR percentage)
  const discountValue = Number(discount?.amount || 0);
  const isPercentage = discount?.type === "PERCENTAGE"; // or discount?.isPercent

  const totalDiscount = Math.round(((isPercentage
    ? (cartSummations.subtotal * discountValue) / 100
    : discountValue) + Number.EPSILON) * 100) / 100;

  // 2. Taxable amount after discount
  const taxableSubtotal = Math.max(0, cartSummations.subtotal - totalDiscount);

  // 3. Tax calculation
  const taxPercent = Number(tax || 0);
  const totalTax = Math.round(((taxableSubtotal * taxPercent) / 100 + Number.EPSILON) * 100) / 100;

  // 4. Final totals
  cartSummations.discount = totalDiscount;
  cartSummations.tax = totalTax;
  cartSummations.subtotal = Math.round((cartSummations.subtotal + Number.EPSILON) * 100) / 100;
  cartSummations.amountDue = Math.round((taxableSubtotal + totalTax + Number.EPSILON) * 100) / 100;
  const totalItems = cart?.length || 0;

  const { totalQty, subtotal, amountDue } = cartSummations;

  const updatePayload = cart.map(({ sku, soldQuantity, batchNo, pricing }) => ({
    sku,
    soldQuantity,
    batchNo,
    subTotal: Math.round((Number(pricing.sellingPrice) * Number(soldQuantity) + Number.EPSILON) * 100) / 100,
    clientId: companyData?.clientId,
    inventoryId: inventory.inventoryId,
  }));

  const $grandTotal = cartSummations.amountDue;

  const onHoldData = useSelector(
    (state) => state.terminalActions.on_holded_sales,
  );
  registerStateRef.current = { registerData, registerClosure, cartCount: cart.length, holdCount: onHoldData?.length || 0 };
  // ITEM SELLING PAYLOAD DATA----------------------

  const d = new Date();
  const YY = String(d.getFullYear()).slice(-2);
  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const HH = String(d.getHours()).padStart(2, "0");
  const MMIN = String(d.getMinutes()).padStart(2, "0");
  const SS = String(d.getSeconds()).padStart(2, "0");

  const receiptRandom = window.crypto?.randomUUID?.().replace(/-/g, "").slice(0, 16)
    || `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  const recieptNo = sales_reciept || `#${YY}${MM}${DD}${HH}${MMIN}${SS}-${receiptRandom}`;
  const customer_Id = customerId;
  const staffData = useSelector((state) => state.clientFunction?.companiesDB?.staffData);

  const salePayloads = {
    registerId: registerData?.registerId,
    salesId: sales_reciept,
    companyData: companyData,
    staffData: staffData,
    submitSale: submitSale,
    discountAmount: cartSummations.discount,
    cart: cart,
    ...(shipping && { shipping }),
    updatesPayload: updatePayload,
    paymentMethods: paymentMethod,
    customerName: customer,
    customerId: customer_Id,
    setLoading: setLoading,
    secondaryFunction: secondaryFunction,
    setAlert: setAlert,
    alert: alert,
    subTotal: cartSummations.subtotal,
    tax: cartSummations.tax,
    ...(discount?.amount && { discount }),
    total: $grandTotal,
    setOpenModal: setOpenModal,
    createdAt: new Date().toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }),
  };
  const fetchSavedContacts = useCallback(async () => {
    if (!companyData?.clientId) return;
    setContactsLoading(true);
    setContactsError("");
    try {
      const { data } = await axios.get(`${serverHost}/client/${encodeURIComponent(companyData.clientId)}/contacts/fetch_contact`, { timeout: 30000 });
      if (![200, 201].includes(data?.status)) throw new Error(data?.message || "Unable to load contacts.");
      setSavedContacts(Array.isArray(data?.nContact) ? data.nContact : []);
    } catch (error) {
      setContactsError(error.response?.data?.message || error.message || "Unable to load contacts.");
    } finally {
      setContactsLoading(false);
    }
  }, [companyData?.clientId]);
  useEffect(() => {
    setSavedContacts([]);
    fetchSavedContacts();
  }, [fetchSavedContacts]);
  const chooseSavedCustomer = (contact) => {
    const id = contact?.contactId || contact?.business?.customerId;
    const name = contact?.profile?.fullName;
    if (contact?.profile?.type?.toLowerCase() !== "customer") {
      setAlert({ type: "warning", message: "Select a saved customer contact." });
      return;
    }
    if (!id || !name) {
      setAlert({ type: "warning", message: "This contact has no saved customer identifier." });
      return;
    }
    setCustomer(name);
    setCustomerId(id);
    setOpenCustomers(false);
    setFilteredContacts([]);
    setSearchTermContacts("");
    setOpenModal(false);
  };
  const handleCreatedContact = (contact) => {
    if (contact?.profile?.type?.toLowerCase() === "customer") chooseSavedCustomer(contact);
    fetchSavedContacts();
  };

  function submitSale(envelope) {
    const decision = access.check({ module: "sales", capability: "sales.create", permission: "sales.create" });
    if (!decision.allowed) {
      setLoading(false);
      setAlert({ type: "warning", message: access.message(decision, "Creating sales") });
      return;
    }
    if (registerCloseRef.current || registerStateRef.current.registerClosure) {
      setLoading(false);
      setAlert({ type: "warning", message: "Check the pending register closure before submitting another sale." });
      return;
    }
    const saleId = envelope.payload.soldItemPayload.saleId;
    if (salePendingRef.current) return;
    if (completedSaleRef.current === saleId) {
      setLoading(false);
      setAlert({ type: "warning", message: "This basket has already been sold. Clear it before starting a new sale." });
      return;
    }
    if (!socket.connected) {
      setLoading(false);
      setAlert({ type: "error", message: "The POS is disconnected. Reconnect before submitting this sale." });
      return;
    }
    salePendingRef.current = saleId;
    setLoading(true);
    clearTimeout(saleTimeoutRef.current);
    saleTimeoutRef.current = setTimeout(() => {
      salePendingRef.current = null;
      setLoading(false);
      setAlert({ type: "warning", message: "Sale confirmation is delayed. Keep this basket and retry the same sale to check its result." });
    }, 20000);
    socket.emit("createSale", envelope);
  }

  // HOURS SPENT IN THE TERMINAL
  const diffMs = Date.now() - new Date(registerData?.timeInn).getTime();
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  const sessionTime = `${hours}:${minutes}HOURS`;

  /////////////////////////////////////////////////////////////////////////
  // REDUX FUCNTIONS
  /////////////////////////////////////////////////////////////////////////
  function toggleScreen() {
    dispatch(Action.switchView(!switchTerminalView));
  }

  const addToCart = useCallback(
    (product) => {
      // A persisted, unconfirmed closure must not disable editing the basket.
      // Checkout remains protected until the server confirms the register is open.
      if (registerCloseRef.current) {
        setAlert({ type: "warning", message: "The register is checking its closing status. Try adding the item again." });
        return { status: 409, outcome: "REGISTER_CHECKING", message: "Register status check in progress." };
      }
      // Check if item already exists in cart
      const existingItem = cart.find(
        (cartItem) => cartItem.sku === product?.sku,
      );

      if (existingItem) {
        // If exists, update quantity
        enqueueSnackbar(`Item already in cart`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        // dispatch(Action.addtoCart(updatedItem));
        return {status:200,outcome:'ALREADY_IN_CART',message:'Item already in cart'};
      } else if (product?.inventories?.stock?.quantity < 1) {
        enqueueSnackbar(`${product?.name} is out of stock.`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        return {status:200,outcome:'OUT_OF_STOCK',message:`${product?.name} is out of stock.`};
      } else {
        // If not exists, add new item
        const intoCart = {
          sku: product?.sku,
          name: product?.name,
          brand: product?.brand,
          invnetoryId: product?.inventories?.inventoryId,
          soldQuantity: product?.inventories?.stock?.sellingQuantity,
          unit: product?.units?.baseUnit,

          pricing: {
            costPrice: product?.pricing?.costPrice,
            sellingPrice: product?.pricing?.sellingPrice,
            discount: 0,
            taxRate: product?.pricing?.taxRate,
            subTotal:
              product?.inventories?.stock?.sellingQuantity *
              product?.pricing?.sellingPrice,
          },

          inventory: {
            inventoryId: product?.inventories?.inventoryId,

            quantity: product?.inventories?.stock?.quantity,

            batchTracking: {
              batchTracking: product?.inventories?.batchTracking?.batchTracking,

              expiryTracking:
                product?.inventories?.batchTracking?.expiryTracking,

              trackingMethod:
                product?.inventories?.batchTracking?.trackingMethod,

              batches: [
                {
                  batchNo:
                    product?.inventories?.batchTracking?.batches?.[0]?.batchNo,

                  costPrice:
                    product?.inventories?.batchTracking?.batches?.[0]
                      ?.costPrice,

                  quantityAvailable:
                    product?.inventories?.batchTracking?.batches?.[0]
                      ?.quantityAvailable,

                  manufactureDate:
                    product?.inventories?.batchTracking?.batches?.[0]
                      ?.manufactureDate,

                  expiryDate:
                    product?.inventories?.batchTracking?.batches?.[0]
                      ?.expiryDate,
                },
              ],
            },
          },

          size: {
            length: product?.dimensions?.length,
            width: product?.dimensions?.width,
            height: product?.dimensions?.height,
          },

          attribute: product?.productType,

          barcode: product?.barcode,

          createdAt: new Date().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          }),
        };
        const contentType = "NEW_TRANACTION";
        dispatch(Action.addtoCart({ intoCart, recieptNo, contentType }));
        return {status:200,outcome:"ADDED",message:`${product.name} added to cart`};
      }
    },
    [cart, dispatch, enqueueSnackbar, recieptNo],
  );

  function clearCart() {
    clearTimeout(salePrintTimeoutRef.current);
    setCompletedReceipt(null);
    dispatch(Action.clearCartAction());
    setOpenModal(false);
  }

  function handleOnHold(note, id) {
    if (salesIdHold && salesIdHold?.includes(id)) {
      setAlert({
        message:
          "This sale is already on hold. Please retrieve it instead of creating a new hold.",
        type: "warning",
      });
    } else {
      const onHoldDatas = {
        saleId: sales_reciept,
        customer_name: customer,
        note: note,
        buyings: cart,
      };

      if (cart.length > 0) {
        dispatch(Action.onHoldPayload(onHoldDatas));
        clearCart();

        enqueueSnackbar(`Sales on hold`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
      } else {
        enqueueSnackbar(`Nothing to put on-hold`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
      }
    }

    setOpenModal(!openModal);
  }

  function handleHoldedSale(note) {
    setOpenModal(!openModal);
  }
  function attendOnHold(data) {
    // Check if item already exists in cart
    if (cart.length > 0) {
      // If exists, update quantity
      const now = new Date();

      const currentCartTransId = sales_reciept;

      if (salesIdHold && salesIdHold?.includes(currentCartTransId)) {
        // IF THE CART INFO ALREADY ON-HOLD
        // Attending the hold transaction
        dispatch(Action.attendOnhold(data));
        setCustomer(data?.customer_name);
      } else {
        // IF THE CART INFO IS NOT IN THE HOLD TRANSACTION

        const onHoldDatas = {
          saleId: sales_reciept,
          customer_name: customer,
          note: `Transaction placed on hold on ${now.toLocaleDateString(
            "en-US",
            {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            },
          )} at ${now.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}. Receipt: ${sales_reciept}`,
          buyings: cart,
        };
        // adding to hold as it does not exist
        dispatch(Action.onHoldPayload(onHoldDatas));

        setAlert({
          message: `Your current transaction has been placed on hold. You may resume it at any time.`,
          type: "info",
        });
        // Attending the hold transaction
        dispatch(Action.attendOnhold(data));
        setCustomer(data?.customer_name);
      }
      // dispatch(Action.addtoCart(updatedItem));
        return {status:200,outcome:'ALREADY_IN_CART',message:'Item already in cart'};
    } else {
      // If not exists, add new item
      dispatch(Action.attendOnhold(data));
      setCustomer(data?.customer_name);
    }
    setOpenModal(false);
  }

  function clearProducts() {
    dispatch(Action.clearProductsAction());
  }

  // Keep the register's request ID stable across Socket.IO and HTTP retries.
  // Both transport paths use the same authenticated, idempotent server operation.
  async function requestRegister(event, envelope) {
    const route = event === "closeRegister" ? "close" : "status";
    let socketFailure;
    if (socket.connected) {
      try {
        const response = await new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error("Socket.IO register confirmation timed out.")), 8000);
          socket.emit(event, envelope, result => {
            clearTimeout(timer);
            if (result?.requestId !== envelope.requestId) {
              reject(new Error("Register confirmation did not match this request."));
              return;
            }
            resolve(result);
          });
        });
        // A server error may be transient, so try the HTTP path. A definite
        // client rejection is returned so the caller can release the journal.
        if (response?.status < 500) return response;
        socketFailure = new Error(response?.message || "Socket.IO register check failed.");
      } catch (error) {
        socketFailure = error;
      }
    }
    try {
      const response = await axios.post(`${serverHost}/pos/register-closure/${route}`, envelope, {
        timeout: 15000,
      });
      if (response.data?.requestId !== envelope.requestId) {
        throw new Error("Register confirmation did not match this request.");
      }
      return response.data;
    } catch (error) {
      // The HTTP controller returns verified rejection codes with a matching
      // request ID. Pass them to the caller rather than hiding the reason.
      if (error.response?.data?.requestId === envelope.requestId &&
          Number.isInteger(error.response.data.status)) return error.response.data;
      throw new Error(error.response?.data?.message ||
        (socketFailure ? "The register result could not be confirmed through either connection. Check Register Status before checkout." :
          "The register could not be reached. Check Register Status before checkout."));
    }
  }

  async function finishRegisterClosure(response, envelope) {
    const record = response?.record;
    const current = registerStateRef.current;
    if (response?.status !== 200 || response.closed !== true || record?.status !== "closed" ||
        record.clientId !== envelope.clientId || record.registerId !== envelope.payload.registerId ||
        record.inventoryId !== envelope.payload.inventoryId || current.registerData.registerId !== record.registerId ||
        current.registerData.clientId !== record.clientId || current.registerData.inventory?.inventoryId !== record.inventoryId ||
        current.cartCount || current.holdCount) throw new Error("Closure could not be verified. Your terminal data has been retained.");
      universeScanner.disconnect();
    dispatch(Action.dispatchCloseRegister(record));
    await persistor.flush();
    redirect("/clients/workspace/terminal-login", { replace: true });
  }

  async function handleCloseRegister(countedCash = null) {
    if (registerCloseRef.current) return;
    const current = registerStateRef.current;
    if (salePendingRef.current || current.cartCount || current.holdCount) {
      if (current.registerClosure && !salePendingRef.current) {
        // Reconcile the pending result without issuing a second close request.
        await checkRegisterStatus();
        return;
      }
      setAlert({ type: "warning", message: "Finalize or clear the current basket and resolve all held sales before closing the register." });
      return;
    }
    const envelope = current.registerClosure || {
      clientId: companyData.clientId, requestId: `CLOSE-${current.registerData.registerId}`,
      payload: { registerId: current.registerData.registerId, inventoryId: current.registerData.inventory.inventoryId, countedCash },
    };
    registerCloseRef.current = true;
    setRegisterClosing(true);
    dispatch(Action.beginRegisterClosure(envelope));
    registerStateRef.current = { ...current, registerClosure: envelope };
    let shouldRecheckStatus = false;
    try {
      // Save the immutable request before sending it. A reload can recover a missed acknowledgment.
      await persistor.flush();
      const status = await requestRegister("getRegisterClosure", envelope);
      if (status.status !== 200) throw new Error(status.message || "Register status could not be checked.");
      if (status.closed) return await finishRegisterClosure(status, envelope);
      if (!status.registered) {
        dispatch(Action.cancelRegisterClosure(envelope.requestId));
        dispatch(Action.requireRegisterLogin());
        await persistor.flush();
        redirect("/clients/workspace/terminal-login", { replace: true });
        return;
      }
      const response = await requestRegister("closeRegister", envelope);
      if (response.status !== 200) {
        // A definite rejection permits continuing the still-open register. Unknown
        // transport/server outcomes retain the journal and require a status check.
        if (response.status >= 400 && response.status < 500) dispatch(Action.cancelRegisterClosure(envelope.requestId));
        throw new Error(response.message || "Register closure could not be confirmed.");
      }
      await finishRegisterClosure(response, envelope);
    } catch (error) {
      shouldRecheckStatus = true;
      setAlert({ type: "warning", message: error.message || "Check Register Status to verify whether the close was saved. Your terminal data has been retained." });
    } finally {
      registerCloseRef.current = false;
      setRegisterClosing(false);
    }
    // If closing failed, check the authoritative server state immediately.
    // Verified-open registers can resume checkout instead of remaining locked.
    if (shouldRecheckStatus) await checkRegisterStatus();
  }

  async function checkRegisterStatus() {
    if (registerCloseRef.current) return;
    const current = registerStateRef.current.registerData;
    if (!current?.registerId || !current?.inventory?.inventoryId || !companyData?.clientId) return;
    const savedClosure = registerStateRef.current.registerClosure;
    try {
      const status = await requestRegister("getRegisterClosure", savedClosure || {
        clientId: companyData.clientId, requestId: `STATUS-${current.registerId}`,
        payload: { registerId: current.registerId, inventoryId: current.inventory.inventoryId },
      });
      if (registerStateRef.current.registerData.registerId !== current.registerId ||
          registerStateRef.current.registerData.clientId !== current.clientId) return;
      if (status.status !== 200) {
        setAlert({ type: "warning", message: status.message || "Unable to verify the current register." });
        return;
      }
      if (status.closed) {
        if (savedClosure && !registerStateRef.current.cartCount && !registerStateRef.current.holdCount) {
          await finishRegisterClosure(status, savedClosure);
          return;
        }
        setAlert({ type: "warning", message: "The register is closed on the server. Your basket has been retained, but checkout is disabled. Clear or preserve the basket before leaving this register." });
        return;
      }
      if (!status.registered) {
        if (savedClosure) dispatch(Action.cancelRegisterClosure(savedClosure.requestId));
        if (!registerStateRef.current.cartCount && !registerStateRef.current.holdCount) {
          dispatch(Action.requireRegisterLogin());
          redirect("/clients/workspace/terminal-login", { replace: true });
        } else {
          setAlert({ type: "warning", message: "This register needs POS PIN verification before checkout. Your basket is retained." });
        }
        return;
      }
      if (savedClosure) {
        // The authoritative server status is still open: release the stale
        // local closure lock. The server's atomic guardSale still rejects any
        // sale if a delayed close ever commits afterward.
        dispatch(Action.cancelRegisterClosure(savedClosure.requestId));
        await persistor.flush();
        setAlert({ type: "info", message: "Register is open. Your basket and transactions are available again." });
      }
    } catch (error) {
      setAlert({ type: "warning", message: error.message || "Could not check the register. Your basket is preserved." });
    }
  }
  // Functional buttons methods of actions
  function handleSaveDraft(note) {
    const billDraft = {
      status: "new-draft",
      customer_name: customer,
      note: note,
      items: cart,
      total: "234a",
      date: new Date().toLocaleString(),
    };
    if (cart.length > 0) {
      dispatch(Action.onHoldPayload({ billDraft }));
      clearCart();
      enqueueSnackbar(`Draft saved successfully`, {
        variant: "success",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    } else {
      enqueueSnackbar(`Nothing to put on-hold`, {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    }
    setOpenModal(false);
  }

  function moveOnHoldToDraft(note) {
    const onHoldDatas = {
      status: "new-draft",
      customer_name: customer,
      note: note,
      items: cart,
      total: "234a",
      date: new Date().toLocaleString(),
    };
    if (cart.length > 0) {
      dispatch(Action.onHoldPayload({ onHoldDatas }));
      clearCart();
      enqueueSnackbar(`Draft saved successfully`, {
        variant: "success",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    } else {
      enqueueSnackbar(`Nothing to put on-hold`, {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: { fontSize: "16px", fontWeight: "bold" },
        },
      });
    }
    setOpenModal(!openModal);
  }

  const salesIdHold = onHoldData?.map((sale) => sale.saleId) || [];

  function secondaryFunction() {
    // clearCart();
    // reactToPrintFn();
    setOpenModal(false);
  }

  function handleSummation() {
    setSummationOpen(!summationOpen);
  }

  // ...................////////
  function handleBillsModalBoxContents() {
    switch (showModalBill) {
      case "expired_subscription":
        return (
          <PlansBilled
            setAlert={setAlert}
            onClose={() => setOpenModalBill(false)}
          />
        );
      default:
        return null;
    }
  }

  function toggleModalBoxContents() {
    switch (showModal) {
      case "recent-transactions":
        return (
          <RecentTransaction setAlert={setAlert} setOpenModal={setOpenModal} />
        );
      case "calculator":
        return <Calculator onClose={() => setOpenModal(false)} />;
      case "itemList":
        return <Items setOpenModal={setOpenModal} clearCart={clearCart} />;
      case "counter":
        return (
          <section className="pos-total-panel" onClick={event => event.stopPropagation()} aria-label="Current sale totals">
            <div className="pos-total-panel__top"><span>LIVE CHECKOUT SUMMARY</span><button type="button" onClick={() => setOpenModal(false)} aria-label="Close sale summary">×</button></div>
            <div className="pos-total-panel__hero"><small>Amount due</small><strong>₦{cartSummations.amountDue.toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong><p>Calculated from the current basket</p></div>
            <div className="pos-total-panel__rows">
              <div><span>Distinct products</span><strong>{totalItems}</strong></div>
              <div><span>Total units</span><strong>{cartSummations.totalQty}</strong></div>
              <div><span>Subtotal</span><strong>₦{cartSummations.subtotal.toLocaleString("en-NG")}</strong></div>
              <div><span>Discount</span><strong>− ₦{cartSummations.discount.toLocaleString("en-NG")}</strong></div>
              <div><span>Tax</span><strong>₦{cartSummations.tax.toLocaleString("en-NG")}</strong></div>
              <div className="pos-total-panel__due"><span>Total payable</span><strong>₦{cartSummations.amountDue.toLocaleString("en-NG")}</strong></div>
            </div>
            <button className="pos-total-panel__done" type="button" onClick={() => setOpenModal(false)}>Continue sale</button>
          </section>
        );
      case "add_new_product":
        return <AddNewProduct handleOnHold={handleOnHold} />;
      case "save_draft":
        return (
          <SaveDraft
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
          />
        );
      case "debit":
        return (
          <Debit
            inventory={inventory}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "multi_pay":
        return (
          <MultiPay
            inventory={inventory}
            sales_reciept={sales_reciept}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "credit_sale":
        return (
          <CreditSale
            inventory={inventory}
            sales_reciept={sales_reciept}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "quotation":
        return (
          <Quotation
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
          />
        );
      case "add-new-contact":
        return <AddNewContact setOpenModal={setOpenModal} initialContactType="Customer" onCreated={handleCreatedContact} />;
      case "clear_cart":
        return (
          <ClearCart
            cart={cart}
            customer={customer}
            clearCart={clearCart}
            setOpenModal={setOpenModal}
            handleOnHold={handleOnHold}
          />
        );
      case "cash_pay":
        return (
          <CashPayment
            inventory={inventory}
            sales_reciept={sales_reciept}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "cheque":
        return (
          <Cheque
inventory={inventory}
            sales_reciept={sales_reciept}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "account":
        return (
          <Account
            inventory={inventory}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "on_hold":
        return (
          <OnHold
            salesPayload={salePayloads}
            handleOnHold={handleOnHold}
            onCancel={()=>setOpenModal(false)}  
            id={sales_reciept}
          />
        );
      case "gift":
        return (
          <Gifting
            inventory={inventory}
            sales_reciept={sales_reciept}
            salesPayload={salePayloads}
            reactToPrintFn={reactToPrintFn}
            setPaymentMethod={setPaymentMethod}
          />
        );
      case "discount":
        return <Discount cart={cart} setOpenModal={setOpenModal} />;
      case "on_hold_sales":
        return (
          <HoldedSales
            onHoldData={onHoldData}
            handleHoldedSale={handleHoldedSale}
            attendOnHold={attendOnHold}
            moveOnHoldToDraft={moveOnHoldToDraft}
          />
        );
      case "contact":
        return (
          <Contacts clientData={companyData} setOpenModal={setOpenModal}
            contacts={savedContacts} loading={contactsLoading} error={contactsError}
            onRefresh={fetchSavedContacts} onSelect={chooseSavedCustomer}
            onAdd={() => setShowModal("add-new-contact")} />
        );
      case "payments":
        return <PaymentLogs />;
      case "chat":
        return <UniCloudChat onClose={() => setOpenModal(false)} />;
      case "register-information":
        return (
          <aside className="registerDetailWrapper" role="dialog" aria-modal="true" aria-label="Register details" onClick={event => event.stopPropagation()}>
            <button type="button" className="register-drawer-close" onClick={() => setOpenModal(false)} aria-label="Close register details">×</button>
            <RegisterDetailsComp />
          </aside>
        );
      case "shipping":
        return <AddShipping salesPayload={salePayloads} setOpenModal={setOpenModal} />;
      case "print-reciept":
        return (
          <PrintSalesReciept
            salesPayload={completedReceipt || salePayloads}
            contentRef={contentRef}
            reactToPrintFn={reactToPrintFn}
            setOpenModal={setOpenModal}
            paymentMethod={paymentMethod}
          />
        );
      case "accept-return":
        return (
          <AcceptReturn
            contentRef={contentRef}
            reactToPrintFn={reactToPrintFn}
            setOpenModal={setOpenModal}
          />
        );

      default:
        return null;
    }
  }
  function handleModalSwitch(event) {
    const restrictions = { discount: "sales.discount", refund: "sales.refund", "sell_return": "sales.refund" };
    const permission = restrictions[event];
    if (permission) {
      const decision = access.check({ module: "sales", capability: permission, permission });
      if (!decision.allowed) {
        setAlert({ type: "warning", message: access.message(decision, event) });
        return;
      }
    }
    setOpenModal(!openModal);
    setShowModal(event);
  }

  function closeModalDiv() {
    setOpenModal(!openModal);
    setShowModal("");
  }

  function switchAsideComp() {
    switch (toggleAside) {
      case "products":
        return (
          <Products
            handleModalSwitch={handleModalSwitch}
            products={products}
            addToCart={addToCart}
            clearCart={clearCart}
          />
        );
      case "properties":
        return <Property handleModalSwitch={handleModalSwitch} />;
      case "activity_log":
        return <TerminalActivityLog />;
      default:
        return (
          <Products
            products={products}
            addToCart={addToCart}
            clearCart={clearCart}
            handleModalSwitch={handleModalSwitch}
          />
        );
    }
  }


  function Main() {
    // ARRAYS

    const customerTypesArray = [
      { id: "EDK323K3J2", name: "Walk-in Customer" },
      { id: "K9X4M7P2QA", name: "Guest Customer" },
      { id: "T8N5R2W1YZ", name: "Cash Customer" },
      { id: "B3Q7L9D6XF", name: "Credit Customer" },
      { id: "N1V8C4M7LK", name: "Wholesale Customer" },
      { id: "P6R2T9Y4GH", name: "Retail Customer" },
      { id: "Z7X3W8Q1BN", name: "VIP Customer" },
      { id: "M5K9D2F8JP", name: "Loyalty Customer" },
      { id: "H4L7S1A9VC", name: "Registered Customer" },
      { id: "Q2W8E5R7TY", name: "Corporate Customer" },
    ];

    const brandsArray = [
      ...new Set(products?.map((n) => n.brand).filter(Boolean)),
    ];

    // END OF ARRAYS
    const handleSearch = (e) => {
      const term = e.target.value;
      setSearchTerm(term);

      if (term.trim() === "") {
        setFilteredProducts([]);
      } else {
        const filtered = products.filter(
          (product) =>
            product?.name.toLowerCase().includes(term.toLowerCase()) ||
            product?.barcode.includes(term),
        );
        setFilteredProducts(filtered);
      }
    };
    const handleSearchBrands = (e) => {
      const term = e.target.value;
      setSearchTermBrands(term);

      if (term.trim() === "") {
        setFilteredBrands([]);
      } else {
        const filtered = brandsArray.filter((brand) =>
          brand.toLowerCase().includes(term.toLowerCase()),
        );
        setFilteredBrands(filtered);
      }
    };
    const handleSearchContacts = (e) => {
      const term = e.target.value;
      setSearchTermContacts(term);
      setFilteredContacts(savedContacts.filter((contact) =>
        [contact?.profile?.fullName, contact?.contact?.phone?.primary, contact?.contact?.email?.primary]
          .join(" ").toLowerCase().includes(term.trim().toLowerCase()) &&
          contact?.profile?.type?.toLowerCase() === "customer"));
    };

    return (
      <div className="main fx-cl space1" onClick={(e) => e.stopPropagation()}>
        <div className="fx-cl">
          <div className="warehouseHubSubjects fx-jb fx-ac space2">
            <div className="warehauseCustomerCont fx-ac spacem">
              <div className="customers_entries-info fx-ac spacem">
                {/* <h4>Customer: </h4> */}
                <div className="customers-page-limit">
                  <button
                    className="customers-page-limit-btn"
                    onClick={() => setOpenCustomers(!openCustomers)}
                  >
                    {customer}
                    <span className="customers-page-limit-arrow">▾</span>
                  </button>

                  {openCustomers && (
                    <ul ref={wrapperRef} className="customers-limit-dropdown">
                      <li>
                        <input
                          id="searchCustomer"
                          type="text"
                          placeholder="Search customer?..."
                          value={searchTermContacts}
                          onChange={handleSearchContacts}
                        />
                      </li>

                      {contactsLoading && <li role="status">Loading saved contacts…</li>}
                      {!contactsLoading && contactsError && <li className="pos-inline-error">{contactsError}</li>}
                      {customerTypesArray.filter((n) => n.name.toLowerCase().includes(searchTermContacts.toLowerCase())).map((n) => (
                        <li key={n.id} className="customers-limit-item" onClick={() => {
                          setCustomer(n.name);
                          setCustomerId(n.id);
                          setOpenCustomers(false);
                          setSearchTermContacts("");
                        }}>{n.name}</li>
                      ))}
                      {filteredContacts.map((contact) => <li key={contact?.contactId || contact?._id}
                        className="customers-limit-item" onClick={() => chooseSavedCustomer(contact)}>
                        {contact?.profile?.fullName} <small>({contact?.profile?.type || "Contact"})</small>
                      </li>)}
                      {!searchTermContacts && savedContacts.filter(c => c?.profile?.type?.toLowerCase() === "customer").slice(0, 15).map((contact) =>
                        <li key={contact?.contactId || contact?._id} className="customers-limit-item" onClick={() => chooseSavedCustomer(contact)}>{contact?.profile?.fullName}</li>)}
                      {searchTermContacts && !filteredContacts.length && !customerTypesArray.some(n => n.name.toLowerCase().includes(searchTermContacts.toLowerCase())) &&
                        <li>No matching customers. <button type="button" onClick={() => { setOpenCustomers(false); setShowModal("add-new-contact"); setOpenModal(true); }}>Add customer</button></li>}
                      <li><button type="button" onClick={() => { setOpenCustomers(false); setShowModal("add-new-contact"); setOpenModal(true); }}>+ New customer</button></li>
                    </ul>
                  )}
                </div>
              </div>

              <div className="TooltipWrapper">
                <button
                  style={{ width: "5rem" }}
                  onClick={() => handleModalSwitch("add-new-contact")}
                >
                  <AddIcCallOutlinedIcon fontSize="large" />
                </button>
                <div className="Tooltip TooltipBottom">Add new contact</div>
              </div>
            </div>

            {!switchTerminalView && (
              <div className="warehauseSearchCont fx-jb space1">
                <div className="fx-ac spacem">
                  <div className=" fx-ac spacem">
                    <div
                      className="warehauseSearch fx-jb"
                      style={{ position: "relative" }}
                    >
                      <input
                        type="text"
                        placeholder="Search product?..."
                        value={searchTerm}
                        onChange={handleSearch}
                      />

                      {filteredProducts.length > 0 && (
                        <div className="searched-products-dropdown fx-cl spacem">
                          <figure className="searchResultHead fs3 fx-ac fx-jb space3 ">
                            <span>
                              Search results:
                              <strong> {filteredProducts.length}</strong>
                            </span>
                            <span>
                              Total quantity:{" "}
                              <strong>
                                {filteredProducts.reduce(
                                  (total, item) =>
                                    total +
                                    (item.inventories?.stock?.quantity || 0),
                                  0,
                                )}
                              </strong>
                            </span>
                          </figure>

                          <ul className="searchResultItems fx-cl spacem">
                            {filteredProducts?.map((product, index) => {
                              return (
                                <li
                                  key={index}
                                  onClick={() => {
                                    addToCart(product);
                                    setFilteredProducts([]);
                                    setSearchTerm("");
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  className="searchedItemCard fx space1"
                                >
                                  <figure className="searchedItemCardIcon fx-ac fx-jc">
                                    <InsertDriveFileIcon
                                      style={{ fontSize: "4.2rem" }}
                                    />
                                  </figure>
                                  <div className="searchedItemCardDiscr fx-ac space1">
                                    <div className="fx-cl spacem">
                                      <div className="fx-ac space3">
                                        <span className="fw500 fs5">
                                          {product?.name}
                                        </span>

                                        <div className="fx-ac spacem">
                                          <span className="itemSearchedTag">
                                            {product?.status}
                                          </span>
                                          {product?.inventories?.stock
                                            ?.quantity < 1 && (
                                            <span
                                              className={`itemSearchedTag finished`}
                                            >
                                              Out of stock
                                            </span>
                                          )}
                                          {product?.inventories?.stock
                                            ?.quantity > 0 &&
                                            product?.inventories?.stock
                                              ?.quantity <=
                                              product?.stock?.minLevel && (
                                              <span className="itemSearchedTag lowStock">
                                                Low stock
                                              </span>
                                            )}
                                        </div>
                                      </div>
                                      <div className="fx-ac space3">
                                        <span>
                                          Quantity:{" "}
                                          {product?.stock?.sellingQuantity}
                                        </span>
                                        <span>
                                          <RemoveIcon fontSize="large" />
                                        </span>
                                        <span>
                                          <strong>brand: </strong>{" "}
                                          {product?.brand}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="fx-cl spacem">
                                      <span className="fs5 fw500">
                                        ₦
                                        {product?.pricing?.sellingPrice?.toLocaleString()}
                                      </span>
                                      <span className="fs1">
                                        sku: {product?.sku}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="camScannerMain TooltipWrapper">
                    <button
                      className="terminalCamScanner fx-ac fx-jc"
                      onClick={() =>
                        setReveal(
                          reveal === "cam-scanner-open"
                            ? ""
                            : "cam-scanner-open",
                        )
                      }
                    >
                      <CameraIcon fontSize="large" />
                    </button>
                    {reveal === "cam-scanner-open" && (
                      <div className="camScannerWraps">
                        <BAR_QR_CODE_SCANNER
                          setReveal={setReveal}
                          reveal={reveal}
                          onScan={handleBarcodeScanWITHCamera}
                        />
                      </div>
                    )}

                    <div className="Tooltip TooltipBottom fs1">
                      Connect your smart Phone to use as Barcode scanner
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="warehouseItemsCont fx-cl space1">
            {switchTerminalView && (
              <div className="warehouseHubBtn fx-ac space1">
                {cart.length > 0 ? (
                  <button
                    className="fx-ac fx-jc"
                    onClick={() => handleModalSwitch("clear_cart")}
                  >
                    <span className="tooltips">Clear Cart</span>
                    {/* MarkIcon */}

                    <DeleteForeverIcon
                      fontSize="large"
                      style={{ color: "#fff" }}
                    />
                  </button>
                ) : (
                  <button
                    className="fx-ac fx-jc"
                    style={{ color: "gray", cursor: "not-allowed" }}
                  >
                    <span className="tooltips">Clear Cart</span>
                    {/* MarkIcon */}

                    <DeleteForeverIcon fontSize="large" />
                  </button>
                )}
                <button className="fx-ac fx-jc" onClick={() => toggleScreen()}>
                  <span className="tooltips">main previews</span>
                  {/* Previews  on Modal box */}

                  <DevicesOtherIcon fontSize="large" />
                </button>
              </div>
            )}

            <div className="warehouseHubMiddleWare fx-ac fx-jb space4">
              <div className="fx-ac space1">
                <button
                  onClick={() => handleModalSwitch("counter")}
                  className="detailsMini fx-ac spacem"
                >
                  <figure className="counterIcon">&nbsp;</figure>
                  <div className="fx-ac space2">
                    <div className="fx-ac spacem">
                      <span>TOTAL:</span>{" "}
                      {cart.length > 0 && (
                        <strong> ₦{$grandTotal?.toLocaleString()}</strong>
                      )}
                    </div>
                  </div>
                </button>

                {onHoldData?.length > 0 && (
                  <button
                    id="onHolds"
                    className="fx-ac spacem fs1 "
                    onClick={() => handleModalSwitch("on_hold_sales")}
                  >
                    <span>{onHoldData?.length || 0} ON HOLD</span>
                  </button>
                )}
                {cart.length > 0 && (
                  <button
                    onClick={() => handleModalSwitch("print-reciept")}
                    className="detailsMini fx-ac spacem"
                  >
                    <LocalPrintshopIcon />
                    <div className="fx-ac space2">
                      <div className="fx-ac spacem">
                        <span>Print Reciept</span>
                      </div>
                    </div>
                  </button>
                )}
                {shipping?.state ? (
                  <LocalShippingOutlinedIcon
                    style={{ fontSize: "2.8rem", color: "#1368ef" }}
                  />
                ) : null}
              </div>
              <div className="fx-ac spacem">
                <div className="icontBtnMiddle fx-ac space1">
                  {discount?.amount && (
                    <span>
                      <DiscountOutlinedIcon
                        fontSize="large"
                        style={{ color: "#26bf89" }}
                      />
                    </span>
                  )}
                  <button
                    // button for camera icon, to open camera for barcode scanning
                    className="cameraBarcodeBtn fx-ac spacem"
                  >
                    <VpnLockOutlinedIcon fontSize="large" />
                  </button>
                </div>
                <div className="brands_entries-info fx-ac spacem">
                  <h4>Brand: </h4>
                  <div className="brands-page-limit">
                    <button
                      className="brands-page-limit-btn"
                      onClick={() => setOpenBrands(!openBrands)}
                    >
                      {brands}
                      <span className="brands-page-limit-arrow">▾</span>
                    </button>

                    {openBrands && (
                      <ul ref={wrapperRef} className="brands-limit-dropdown">
                        <li>
                          <input
                            type="text"
                            placeholder="Search brand..."
                            value={searchTermBrands}
                            onChange={handleSearchBrands}
                          />
                        </li>

                        {filteredBrands.length > 0
                          ? filteredBrands?.map((brand) => (
                              <li
                                key={brand}
                                onClick={() => {
                                  setBrands(brand);
                                  setOpenBrands(false);
                                }}
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                }}
                              >
                                {brand}
                              </li>
                            ))
                          : brandsArray?.map((brand) => (
                              <li
                                key={brand}
                                className="brands-limit-item"
                                onClick={() => {
                                  setBrands(brand);
                                  setOpenBrands(false);
                                }}
                              >
                                {brand}
                              </li>
                            ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="fx-ac fx-jb space5">
              <div className="fx-ac space1">
                <button 
                  className="warehouseHubCounts fx-ac fx-jb space3"
                >
                  <div className="fx-ac spacem">
                    <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                      <ShoppingCartIcon fontSize="medium" /> Cart:
                    </strong>
                    {cart?.length < 1 ? (
                      "empty"
                    ) : (
                      <span>
                        {cart?.length} <em>items</em>
                      </span>
                    )}
                  </div>
                </button>
                <div className="fx-ac space1">
                  <div style={{ display: "none" }}>
                    <PrintSalesReciept
                      salesPayload={completedReceipt || salePayloads}
                      contentRef={contentRef}
                      reactToPrintFn={reactToPrintFn}
                      setOpenModal={setOpenModal}
                    />
                  </div>

                  <button
                    className="controlButtons"
                    onClick={() => {
                      if (cart.length > 0) {
                        handleModalSwitch("quotation");
                      }
                    }}
                    style={{
                      cursor: cart.length > 0 ? "pointer" : "not-allowed",
                      opacity: cart.length > 0 ? 1 : 0.6, // optional, to show disabled look
                    }}
                  >
                    <FormatQuoteIcon />
                    <span>Quotes</span>
                    {/* <span class="tooltips">Print Quatation</span> */}
                  </button>
                  <button
                    className="controlButtons"
                    onClick={() => {
                      if (cart.length > 0) {
                        handleModalSwitch("on_hold");
                      }
                    }}
                    style={{
                      cursor: cart.length > 0 ? "pointer" : "not-allowed",
                      opacity: cart.length > 0 ? 1 : 0.6, // optional, to show disabled look
                    }}
                  >
                    <PanToolIcon />
                    <span>On-hold</span>
                  </button>
                  <button
                    className="controlButtons"
                    onClick={() => {
                      if (cart.length > 0) {
                        handleModalSwitch("save_draft");
                      }
                    }}
                    style={{
                      cursor: cart.length > 0 ? "pointer" : "not-allowed",
                      opacity: cart.length > 0 ? 1 : 0.6, // optional: show disabled look
                    }}
                  >
                    <SaveAsIcon />
                    <span>Save draft</span>
                  </button>
                </div>
              </div>

              <div className="fx-ac disappearingToggle space1">
                {contentType === "ON_HOLD_TRANSACTION" && (
                  <button
                    id="btnDeleteOnHold"
                    className="fx-ac spacem"
                    onClick={() => {
                      dispatch(Action.deleteOnholdDispatch(sales_reciept));
                      clearCart();
                    }}
                  >
                    <DeleteForeverIcon />
                    <span>Delete</span>
                  </button>
                )}
              </div>

              <span id="recieptId">{sales_reciept}</span>
            </div>

            {/* ____________CART ITEMS MAPPING___________ */}
            <Items />
          </div>
        </div>
        <div className="tenderTypesCont warehouseHubOperations btns fx-ac space1 fx-jc">
          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("account");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6, // optional, to show disabled look
            }}
          >
            <AccountBalanceIcon />
            <span>Account</span>
          </button>
          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("cheque");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6, // optional: show disabled look
            }}
          >
            <ReceiptLongIcon />
            <span>Cheque</span>
          </button>

          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("credit_sale");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6,
            }}
          >
            <SellIcon />
            {/* Press CREDIT
→ terminal charges card
→ cashier confirms success
→ sale completed */}
            <span>Credit sale</span>
          </button>

          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("cash_pay");
              }
            }}
            className="cashPaid fx-jc"
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6,
            }}
          >
            Cash Paid
          </button>
          {/* <button> Cheque
              Customer gives cheque
→ cashier records cheque number
→ sale marked pending clearance
            </button> */}

          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("multi_pay");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6,
            }}
          >
            <LayersClearIcon />
            <span>Multi-pay</span>
          </button>

          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("debit");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6,
            }}
          >
            <AssuredWorkloadIcon />
            <span>Debit</span>
          </button>

          <button
            onClick={() => {
              if (cart.length > 0) {
                handleModalSwitch("gift");
              }
            }}
            style={{
              cursor: cart.length > 0 ? "pointer" : "not-allowed",
              opacity: cart.length > 0 ? 1 : 0.6,
            }}
          >
            <CardGiftcardIcon />
            {/* Customer uses store balance
→ system deducts gift balance
→ sale completes */}
            <span>Gift</span>
          </button>
        </div>
        <div className="warehouseHubFooter fx-ac fx-jc">
          <span className="fs1 fw600">Copyright © 2026 Universe Inventory. All rights reserved.</span>
        </div>
      </div>
    );
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      // 1. Guard against detached/unmounted DOM nodes
      if (!document.body.contains(event.target)) return;
      if (event.target.closest?.(".pos-calculator")) return;

      // 2. Check if click is outside wrapperRef
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setFilteredProducts(() => []); // Functional update guarantees fresh queue
        setOpenCustomers(false);
        setOpenBrands(false);
        setReveal(() => ""); // Functional update guarantees fresh queue
      }
    };

    document.addEventListener("pointerdown", handleClickOutside, true);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    let lastActivity = Date.now();
    let mouseDown = false;

    const updateActivity = () => {
      lastActivity = Date.now();
    };

    const onMouseDown = () => {
      mouseDown = true;
      updateActivity();
    };

    const onMouseUp = () => {
      mouseDown = false;
      updateActivity();
    };

    const onKeyDown = () => {
      updateActivity();
    };

    const onTouchStart = () => {
      updateActivity();
    };

    const shouldFocusBarcode = () => {
      const input = barcodeInputRef.current;
      // Calculator keyboard input must not be stolen by barcode focus recovery.
      if (document.querySelector(".pos-calculator")) return false;

      if (!input) return false;

      // Already focused
      if (document.activeElement === input) return false;

      // User is dragging/selecting
      if (mouseDown) return false;

      // User has selected text
      const selection = window.getSelection();
      if (selection && selection.toString().length > 0) return false;

      // User is typing in another field
      const active = document.activeElement;

      if (
        active &&
        active !== input &&
        active.matches("input, textarea, select, [contenteditable='true']")
      ) {
        return false;
      }

      // Wait until user has been idle
      if (Date.now() - lastActivity < 3000) return false;

      // Don't focus hidden/disabled inputs
      if (input.disabled) return false;
      if (input.offsetParent === null) return false;

      return true;
    };

    const interval = setInterval(() => {
      if (shouldFocusBarcode()) {
        barcodeInputRef.current.focus();
      }
    }, 200);

    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("touchstart", onTouchStart);

    return () => {
      clearInterval(interval);

      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("touchstart", onTouchStart);
    };
  }, []);

  // -------------------------- BILL PAYMENT CONFIRMATION FOR COMPANIES --------------------
  function alertPaymentBill() {
    const planIndexes = {
      standard: "0",
      professional: "1",
      premium: "2",
      enterprise: "3",
    };
    const slug = companyData?.subscription?.planName?.toLowerCase();

    setSearchParams({
      plan: slug,
      index: planIndexes[slug] ?? "2",
    });
    setOpenModalBill(true);
    setShowModalBill("expired_subscription");
  }
  useEffect(() => {
    const expiryDate = companyData?.subscription?.expiryDate;

    if (!expiryDate) return;

    if (new Date(expiryDate) <= new Date()) {
      setAlert({
        type: "warning",
        message:
          "Your subscription has expired. Please renew to continue using our services.",
      });

      const intervalId = setTimeout(() => {
        if (!openModalBill) {
          alertPaymentBill();
        }
      }, 7000);
    }
  }, [companyData]);

  // ============================================================
  // SOCKET.IO CONNECTION
  // ============================================================

  useEffect(() => {
    const joinInventory = () => {
      socket.emit("joinPOS", { companyId: companyData?.clientId, inventoryId: inventory.inventoryId });
      checkRegisterStatus();
    };
    const handleDisconnect = () => {
      if (!salePendingRef.current) return;
      clearTimeout(saleTimeoutRef.current);
      salePendingRef.current = null;
      setLoading(false);
      setAlert({ type: "warning", message: "Connection lost before sale confirmation. Keep this basket and retry the same sale after reconnecting." });
    };
    const handleAccessFailure = failure => {
      setLoading(false);
      setAlert({ type: "error", message: failure?.message || "Unable to access this POS session. Please sign in again." });
    };
    socket.on("posJoinFailed", handleAccessFailure);
    socket.on("connect_error", handleAccessFailure);
    socket.on("connect", joinInventory);
    socket.on("disconnect", handleDisconnect);
    socket.connect();
    if (socket.connected) joinInventory();
    return () => {
      clearTimeout(saleTimeoutRef.current);
      clearTimeout(salePrintTimeoutRef.current);
      socket.off("posJoinFailed", handleAccessFailure);
      socket.off("connect_error", handleAccessFailure);
      socket.off("connect", joinInventory);
      socket.off("disconnect", handleDisconnect);
      socket.disconnect();
    };
  }, [companyData?.clientId, inventory.inventoryId]);

  // USEEFFECT LISTENING TO THE SOCKET EMIT RESPONSE
  useEffect(() => {
    const handleSaleCompleted = (response) => {
      if (response?.saleId && response.saleId !== sales_reciept) return;
      if (completedSaleRef.current === sales_reciept) return;
      clearTimeout(saleTimeoutRef.current);
      salePendingRef.current = null;
      setLoading(false);
      if (response?.status === 200) {
        const receipt = response.poinOfSaleSoldData?.saleReceipt;
        completedSaleRef.current = sales_reciept;
        dispatch(Action.deleteOnholdDispatch(sales_reciept));
        dispatch(Action.updateProductsFromSocket(response.poinOfSaleSoldData?.updatedProducts));
        if (receipt) setCompletedReceipt({
          ...salePayloads,
          salesId: receipt.saleId,
          cart: receipt.soldItems,
          customerId: receipt.customerId,
          customerName: receipt.customer_name,
          subTotal: receipt.totals.subtotal,
          discount: receipt.totals.discount,
          discountAmount: receipt.totals.discountAmount,
          tax: receipt.totals.taxAmount,
          total: receipt.totals.total,
          paymentMethods: receipt.payment.method,
          createdAt: new Date(receipt.createdAt).toLocaleString(),
        });
        new Audio(SuccessSound).play().catch(() => {});
        setAlert({
          message: `${response.message || "Sale completed."} ${receipt?.soldItems?.length ?? cart.length} item(s).`,
          type: "success",
        });
        clearTimeout(salePrintTimeoutRef.current);
        salePrintTimeoutRef.current = setTimeout(() => reactToPrintFn(), 6100);
      } else {
        new Audio(ErrorSound).play().catch(() => {});
        setAlert({ message: response?.message || "Failed to process sale.", type: "error" });
      }
    };
    const handleSaleFailed = (response) => {
      if (response?.saleId && response.saleId !== sales_reciept) return;
      if (completedSaleRef.current === sales_reciept) return;
      clearTimeout(saleTimeoutRef.current);
      salePendingRef.current = null;
      setLoading(false);
      new Audio(ErrorSound).play().catch(() => {});
      setAlert({ message: response?.message || "Failed to process sale.", type: "error" });
    };
    const handleInventoryUpdated = (updatedProducts) => {
      dispatch(Action.updateProductsFromSocket(updatedProducts));
    };
    socket.on("saleCompleted", handleSaleCompleted);
    socket.on("inventoryUpdated", handleInventoryUpdated);
    socket.on("saleFailed", handleSaleFailed);
    return () => {
      socket.off("saleCompleted", handleSaleCompleted);
      socket.off("inventoryUpdated", handleInventoryUpdated);
      socket.off("saleFailed", handleSaleFailed);
    };
  }, [cart.length, sales_reciept, reactToPrintFn]);

  // FUNCTIONS TO CLOSE ALL OVERLAYS ON ESCAPE
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setDisplay("");
        setDisplay("");
        setScannerVisible(false);
        setSearchTerm("");
        setFilteredProducts([]);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setReveal]);


  // SLIDING ANIMATIONS 
 
const scannerSessionToken=useSelector(state=>state.clientFunction?.sessionToken);
const scannerSocketRef=useRef(null);
if(!scannerSocketRef.current)scannerSocketRef.current=io(socket.io.uri,{autoConnect:false});
const universeScanner=useUniverseScanner({socket:scannerSocketRef.current,sessionToken:scannerSessionToken,clientId:companyData?.clientId,inventoryId:inventory?.inventoryId,registerId:registerData?.registerId,timeInn:registerData?.timeInn,label:inventory?.inventoryName||'Universe web POS',products,addToCart});
const [scannerVisible, setScannerVisible] = useState(false);
const [scannerClosing, setScannerClosing] = useState(false);

const toggleCloudScanner = () => {
  if (scannerVisible) {
    // Start closing animation
    setScannerClosing(true);

    // Remove after animation completes
    setTimeout(() => {
      setScannerVisible(false);
      setScannerClosing(false);
    }, 420);

    return;
  }

  // Open
  setScannerVisible(true);
  setScannerClosing(false);
};

  return (
    <section className="sectionwarehouseHub fx-cl">
      {alert && <AlertBar alert={alert} setAlert={setAlert} />}
      {
        <div id="barcodeScannerWITH_READER">
          <input
            ref={barcodeInputRef}
            type="text"
            value={scannedEvent}
            onChange={(e) => setScannedEvent(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Tab" || e.key === "Space") {
                if (scannedEvent.length > 0) {
                  handleBarcodeScan();
                }
              }
            }}
          />
        </div>
      }

      {loading && <IsLoading />}
    {scannerVisible && (
  <div className="displayOverlay fx-ac fx-je">
    <CloudScanner closing={scannerClosing} scanner={universeScanner} onClose={toggleCloudScanner} />
  </div>
)}

      {openModalBill && (
        <div id="modalBilledContainer" onClick={() => setOpenModalBill(false)}>
          {handleBillsModalBoxContents()}
        </div>
      )}
      {openModal && (
        <div id="modalContainer" className={showModal === "register-information" ? "pos-register-drawer-overlay" : showModal === "chat" ? "pos-chat-drawer-overlay" : showModal === "shipping" ? "pos-shipping-drawer-overlay" : ""} onClick={() => closeModalDiv()}>
          {toggleModalBoxContents()}
        </div>
      )}
      {!switchTerminalView ? (
        <div className="warehouseHubCont fx-cl space2" id="largeView">
          <div className="taskBar fx-cl fx-ac fx-jc space1">
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("discount")}>
                <DiscountIcon fontSize="large" />
              </button>
              <div className="Tooltip TooltipRight">Discount</div>
            </div>
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("shipping")}>
                <LocalShippingIcon fontSize="large" />
              </button>
              <div className="Tooltip TooltipRight">Shipping</div>
            </div>{" "}
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("recent-transactions")}>
                <ReceiptLongIcon fontSize="large" />
              </button>
              <div className="Tooltip TooltipRight">Present Transactions</div>
            </div>
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("payments")}>
                <AccountBalanceIcon fontSize="large" />
              </button>
              <div className="Tooltip TooltipRight">Payments</div>
            </div>{" "}
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("contact")}>
                <SettingsPhoneIcon fontSize="large" />
              </button>
              <div className="Tooltip TooltipRight">Your Contacts</div>
            </div>{" "}
            <div className="TooltipWrapper">
              <button onClick={() => handleModalSwitch("chat")} aria-label="Open UniCloud communication"><HeadsetMicIcon fontSize="large" /></button>
              <div className="Tooltip TooltipRight">Communicate</div>
            </div>
          </div>

          {cart?.length > 0 && (
            <figure className="termanalSummationCard fx-ac spacem">
              {summationOpen && (
                <div className="termanalSummationCardDisc fx-cl spacem">
                  <div className="fx-jb space4">
                    <span className="fs3 fw500">Grand Total</span>
                    <span className="fs7 fw300">
                      <strong>
                        ₦
                        {subtotal.toLocaleString("en-NG", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </strong>
                    </span>
                  </div>

                  <div className="g g2">
                    {/* Total Items */}
                    <div className="fx-ac spacem">
                      <span>Total Items:</span>

                      <span>
                        <strong>{totalItems}</strong>
                      </span>
                    </div>

                    {/* Total Quantity */}
                    <div className="fx-ac spacem">
                      <span>Total QTY:</span>

                      <span>
                        <strong>{totalQty}</strong>
                      </span>
                    </div>

                    {/* Subtotal */}
                    <div className="fx-ac spacem">
                      <span>Subtotal:</span>

                      <span>
                        <strong>
                          ₦
                          {subtotal.toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div>

                    {/* Discount */}
                    <div className="fx-ac spacem">
                      <span>Discount:</span>

                      <span>
                        <strong>
                          ₦
                          {(Number(discount?.amount ?? 0) || 0)?.toLocaleString(
                            "en-NG",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </strong>
                      </span>
                    </div>

                    {/* Tax */}
                    <div className="fx-ac spacem">
                      <span>Tax:</span>

                      <span>
                        <strong>
                          ₦
                          {tax.toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div>

                    {/* Amount Due */}
                    <div className="fx-ac spacem">
                      <span>Amount Due:</span>

                      <span>
                        <strong>
                          ₦
                          {amountDue.toLocaleString("en-NG", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <button onClick={() => handleSummation()}>
                {summationOpen ? (
                  <ArrowBackIosRoundedIcon fontSize="large" />
                ) : (
                  <ArrowForwardIosRoundedIcon fontSize="large" />
                )}
              </button>
            </figure>
          )}
          <TerminalConsole
            display={display}
            setDisplay={setDisplay}
            scannerVisible={scannerVisible}
            toggleCloudScanner={toggleCloudScanner}
            toggleFullscreen={toggleFullscreen}
            isFullscreen={isFullscreen}
            companyData={companyData}
            handleCloseRegister={handleCloseRegister}
            registerClosing={registerClosing}
            addToCart={addToCart}
            handleModalSwitch={handleModalSwitch}
            toggleScreen={toggleScreen}
            setAlert={setAlert}
            reveal={reveal}
            setReveal={setReveal}
            cart={cart}
          />

          {Main()}
        </div>
      ) : (
        <div className="warehouseHubCont">
          <div className="warehouseHubHeader">
            <div className="warehouseHubheaderCont fx-ac fx-jb space6">
              <figure className="fx-ac space1">
                <div
                  className="fx-ac fx-jc"
                  style={{
                    backgroundColor: "#F5F5F5",
                    borderRadius: "300rem",
                    width: "4rem",
                    height: "4rem",
                    padding: ".5rem",
                  }}
                >
                  <SchoolIcon fontSize="large" />
                </div>
                <div className="fx-cl">
                  <p className="warehousehubHeading">
                    <strong>
                      {companyData?.businessProfile?.basicInfo?.businessName}:
                    </strong>{" "}
                    Inventory Terminal
                  </p>
                  <div className="warehousehubStatusBar fx-ac spacem">
                    <span>
                      <strong>User: </strong> {companyData?.founder?.firstName}
                    </span>
                    <span
                      className="fx-ac spacem"
                      style={{
                        borderRight: "1px solid #999",
                        borderLeft: "1px solid #999",
                        padding: "0rem .4rem",
                      }}
                    >
                      <ShoppingCartCheckoutIcon />
                      <span>
                        <strong>{itemsSoldCount} </strong>
                        ITEMS SOLD
                      </span>
                    </span>
                    <span className="fx-ac spacem">
                      <AccessTimeIcon />
                      <span>{sessionTime}</span>
                    </span>
                  </div>
                </div>
              </figure>

              <figure className="warehouseHubRight fx-ac spacem">
                <button type="button" className="fx-ac fx-jc cbtdp"
                  onClick={() => handleModalSwitch("calculator")}
                  title="Open Calculator" aria-label="Open Calculator">
                  <CalculateIcon fontSize="large" />
                </button>
                <SatelliteAltIcon
                  style={{ color: "#f16b4c", fontSize: "2.8rem" }}
                />
                <div className="fx-ac">
                  <button
                    className="fx-ac fx-jc cbtdp"
                    onClick={() => handleCloseRegister()}
                    disabled={registerClosing}
                    title={registerClosing ? "Closing register..." : "Close Register"}
                  >
                    <PowerSettingsNewIcon fontSize="large" />
                  </button>
                </div>
              </figure>
            </div>
          </div>
          <div className="warehouseHubMain fx-jc space1">
            {Main()}
            <div className=" fx-cl fx-ac">
              <div className="warehouseHubAsideNav fx-ac spacem">
                <button
                  onClick={() => setToggleAside("products")}
                  className={`fx-ac spacem ${toggleAside === "products" && "active"}`}
                >
                  <CasesIcon /> <span>Products</span>
                </button>
                <button
                  onClick={() => setToggleAside("properties")}
                  className={`fx-ac spacem ${toggleAside === "properties" && "active"}`}
                >
                  <VideoLibraryRoundedIcon /> <span>Properties </span>
                </button>
                <button
                  onClick={() => setToggleAside("activity_log")}
                  className={`fx-ac spacem ${toggleAside === "activity_log" && "active"}`}
                >
                  <EventRoundedIcon /> <span>Activity log</span>
                </button>
              </div>
              <div className="aside fx-cl space1">
                <div>{switchAsideComp()}</div>
              </div>
            </div>
          </div>
          {/* <div className="warehouseHubFooter fx-ac fx-jc">
            <span>status bar contents</span>
          </div> */}
        </div>
      )}
    </section>
  );
}

function Property({ handleModalSwitch }) {
  const shortcuts = [
    { label: "Discount", modal: "discount", icon: <DiscountIcon /> },
    { label: "On-hold sales", modal: "on_hold_sales", icon: <PanToolIcon /> },
    { label: "Accept Return", modal: "accept-return", icon: <ReceiptLongIcon /> },
    { label: "Shipping", modal: "shipping", icon: <LocalShippingIcon /> },
    { label: "Contacts", modal: "contact", icon: <PeopleAltRoundedIcon /> },
    { label: "Recent sales", modal: "recent-transactions", icon: <ReceiptLongIcon /> },
    { label: "Payments", modal: "payments", icon: <AccountBalanceIcon /> },
    { label: "Add new item", modal: "add_new_product", icon: <AddIcon /> },
    { label: "Team messages", modal: "chat", icon: <HeadsetMicIcon /> },
  ];
  return <div className="warehousePropertCont pos-properties">
    <div className="pptyTopCont fx-cl space2"><span className="pos-eyebrow">TRANSACTION WORKSPACE</span>
      <h3>Quick actions</h3><p>Manage this register using verified inventory and sale tools.</p>
      <p className="pos-property-hint">For actual earnings and cash totals, open Register Details. No estimated sales values are displayed.</p>
    </div>
    <div className="pptyBtnCont g g3 space1">{shortcuts.map(({ label, modal, icon }) =>
      <figure key={modal} className="fx-cl spacem"><button type="button" aria-label={label} onClick={() => handleModalSwitch(modal)}>{icon}</button><span>{label}</span></figure>
    )}</div>
  </div>;
}
function Products({ handleModalSwitch, products, addToCart, clearCart }) {
  /////////////////////////////////////////////////////////////////////////
  // SEARCH FILTER FUNCTOINS
  /////////////////////////////////////////////////////////////////////////

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === "") {
      setFilteredProducts([]);
    } else {
      const filtered = products.filter(
        (product) =>
          product?.name.toLowerCase().includes(term.toLowerCase()) ||
          product?.barcode.includes(term),
      );
      setFilteredProducts(filtered);
    }
  };

  const handleSelect = (product) => {
    setSearchTerm(product?.name);
    setFilteredProducts([]); // close dropdown after selection
  };

  function switchProductView() {
    if (filteredProducts.length > 0) {
      return (
        <div className="items_product_cont g g3 space1">
          {filteredProducts?.map((product, index) => {
            return (
              <figure
                onClick={() => {
                  addToCart(product);

                  setFilteredProducts("");
                  setSearchTerm("");
                }}
                key={index}
                className="productsCardWH fx-cl space1 fx-jb"
              >
                <h4>{product?.name}</h4>
                <div>
                  <p>₦{product?.pricing?.sellingPrice}</p>
                </div>
              </figure>
            );
          })}
        </div>
      );
    } else if (searchTerm.trim() !== "") {
      return <p className="no-products-found">No products found</p>;
    } else {
      return (
        <div className="items_product_cont g g3 space1">
          {products?.map((product, index) => {
            return (
              <figure
                onClick={() => {
                  addToCart(product);
                }}
                key={index}
                className="productsCardWH fx-cl space1 fx-jb"
              >
                <h4>{product?.name}</h4>
                <div>
                  <p>₦{product?.pricing?.sellingPrice}</p>
                </div>
              </figure>
            );
          })}
        </div>
      );
    }
  }

  return (
    <div className="fx-cl space1">
      <div className="warehauseSearchCont fx-jb space3">
        <div className=" fx-ac spacem">
          <div
            className="warehauseSearch fx-jb"
            style={{ position: "relative" }}
          >
            <input
              type="text"
              placeholder="Search product?..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          {/* <button>
            <SearchIcon fontSize="large" />
          </button> */}
        </div>
        {/* <button
          className="terminalCamScanner fx-ac fx-jc"
          onClick={() => handleModalSwitch("add_new_product")}
        >
          <AddIcon fontSize="large" />
        </button> */}
      </div>
      {switchProductView()}
    </div>
  );
}
export default InventoryTerminal;
